import { colors } from '../../styles/colors';

export const CM_COLOUR_SCALE: { [key: string]: string } = {
  Low: colors.map.riskLow,
  Medium: colors.map.riskMed,
  High: colors.map.riskHigh,
};
